import React from 'react';
import _ from 'lodash';

export default function Hit(data) {
  const { hit } = data;
  const {
    id,
    title,
    uri,
    account,
    image,
    attribution,
    primaryArtistName,
    year,
  } = hit;

  return (
    <div className="grid-item" key={id}>
      <div className="card-bookmark">
        <a href={window.Craft.getSiteUrl(uri)} className="card-image">
          <img
            src={_.get(
              image,
              'transforms.catalog.url',
              _.get(
                image,
                'url',
                null,
              ),
            )}
            alt={title}
          />
        </a>
        <div className="card-text">
          <span className="subtitle text-uppercase">
            <a
              href={window.Craft.getSiteUrl(account.uri)}
              className="artwork-catalog__artwork-title-exhibitor"
            >
              {account.title}
            </a>
          </span>
          <a
            href={window.Craft.getSiteUrl(uri)}
            className="artwork-catalog__artwork-title"
          >
            <h3>
              {[attribution, primaryArtistName]
                .filter((artistInfo) => artistInfo)
                .join(' ')
                .trim()}
            </h3>
            <span className="card-title ff-portrait">
              <i>{title}</i>
              {year && (
                <span>
                  ,
                  &nbsp;
                  {year}
                </span>
              )}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
